module.exports = __webpack_public_path__ + "static/media/image 10.7226dbd4.png";